(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbAppLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbAppLib"] = factory();
	else
		root["sbAppLib"] = factory();
})(window, function() {
return 